import styled from "styled-components";
import React from "react";
// @ts-ignore
import classnames from "classnames";

const Wrapper = styled.div`
  height: 10vh;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  .bridge__bar {
    border-left: 2px solid red;
    border-right: 2px solid red;
    border-radius: 4px;
    display: inline-block;
    height: 4%;
    transition: height 0.5s ease-out;
    width: 0;
    margin: 0 5px;
  }

  &.is-loaded {
    & .bar-1 {
      height: 6%;
    }

    & .bar-2 {
      height: 10%;
    }

    & .bar-3 {
      height: 16%;
    }

    & .bar-4 {
      height: 26%;
    }

    & .bar-5 {
      height: 40%;
    }

    & .bar-6 {
      height: 60%;
    }
  }
`;

interface Props {
  showBridge: boolean
}

const SplashBridge = ({ showBridge }: Props) => {
  return (
    <Wrapper className={ classnames('bridge', { 'is-loaded': showBridge }) }>
      <span className='bridge__bar bar-0' />
      <span className='bridge__bar bar-1' />
      <span className='bridge__bar bar-2' />
      <span className='bridge__bar bar-3' />
      <span className='bridge__bar bar-4' />
      <span className='bridge__bar bar-5' />
      <span className='bridge__bar bar-6' />
      <span className='bridge__bar bar-5' />
      <span className='bridge__bar bar-4' />
      <span className='bridge__bar bar-3' />
      <span className='bridge__bar bar-2' />
      <span className='bridge__bar bar-1' />
      <span className='bridge__bar bar-0' />
      <span className='bridge__bar bar-1' />
      <span className='bridge__bar bar-2' />
      <span className='bridge__bar bar-3' />
      <span className='bridge__bar bar-4' />
      <span className='bridge__bar bar-5' />
      <span className='bridge__bar bar-6' />
      <span className='bridge__bar bar-5' />
      <span className='bridge__bar bar-4' />
      <span className='bridge__bar bar-3' />
      <span className='bridge__bar bar-2' />
      <span className='bridge__bar bar-1' />
      <span className='bridge__bar bar-0' />
    </Wrapper>
  )
};

export default SplashBridge;
